import { ListViewLocalChildProps } from '@app/core/list-view/ListViewLocal';
import { FleetBalenaDeviceDto } from '@mi-front/api-v2';
import { useQueryParam } from '@mi-front/core';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useIntl } from 'react-intl';
import { BalenaDeviceCard } from '../balena-device-card/BalenaDeviceCard';
import { BalenaDevicesGridSkeleton } from './BalenaDevicesGridSkeleton';

export type BalenaDevicesGridProps = ListViewLocalChildProps<FleetBalenaDeviceDto>;

/**
 * Card grid of Balena devices (no pagination — full filtered set).
 */
export function BalenaDevicesGrid({ data, isLoading = false }: BalenaDevicesGridProps) {
  const { $t } = useIntl();
  const forceSkeleton = useQueryParam('skeleton');

  if (isLoading || forceSkeleton) {
    return <BalenaDevicesGridSkeleton />;
  }

  if (!data.length) {
    return (
      <Box sx={{ py: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          {$t({
            id: 'common.noResults',
            defaultMessage: 'Sin resultados',
          })}
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={2.5}>
      {data.map((device) => (
        <Grid size={{ xs: 12, sm: 6, lg: 6, xl: 4 }} key={device.uuid || device.id}>
          <BalenaDeviceCard device={device} />
        </Grid>
      ))}
    </Grid>
  );
}
